<template>
    <v-stepper-header>
        <template v-for="(step, index) in steps">
            <StepSummaryItem
                :key="`step-${index}`"
                :class="{
                    'pl-4': index === 0,
                    'pr-4': index === steps.length - 1
                }"
                :currentStep="currentStep"
                :stepId="(index + 1)"
                :step="step"
            />
            <v-divider
                v-if="index < steps.length - 1"
                :key="index"
            />
        </template>
    </v-stepper-header>
</template>

<script>
    import StepSummaryItem from '@/components/myHabiteoStudio/components/StepSummaryItem';

    export default {
        name: 'StepSummaryItems',
        components: {
            StepSummaryItem
        },
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            steps: {
                type: Array,
                required: true
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepSummaryItems.vue